import { render, staticRenderFns } from "./AdminAreaBranchDetail.vue?vue&type=template&id=19f19365&scoped=true&"
import script from "./AdminAreaBranchDetail.vue?vue&type=script&lang=js&"
export * from "./AdminAreaBranchDetail.vue?vue&type=script&lang=js&"
import style0 from "./AdminAreaBranchDetail.vue?vue&type=style&index=0&id=19f19365&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f19365",
  null
  
)

export default component.exports